import React from 'react';
import { ArrowDown } from '@phosphor-icons/react';

interface CollapsibleSectionProps {
    title: string;
    isOpen: boolean;
    onToggle: () => void;
    children: React.ReactNode;
    titleTooltip?: string;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({ 
    title, 
    isOpen, 
    onToggle, 
    children, 
    titleTooltip 
}) => {
    return (
        <div>
            <h4
                className="relative pl-[40px] leading-[30px] cursor-pointer text-md font-medium text-layout-textcolor m-0"
                onClick={onToggle}
            >
                <div className="absolute w-fit h-fit bottom-0 left-0 m-auto">
                    <button
                        className="rounded-full h-[25px] md:h-[30px] w-[25px] md:w-[30px] transition-all duration-100 text-chatInput-sendButtonColor bg-chatInput-sendButtonBackground hover:bg-chatInput-sendButtonBackground-hover border-none flex items-center justify-center"
                        title={titleTooltip || (isOpen ? 'Hide' : 'Show')}
                        type="button"
                    >
                        <ArrowDown
                            size={20}
                            style={{
                                transform: isOpen ? 'rotate(-180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease',
                            }}
                        />
                    </button>
                </div>
                {title}
            </h4>
            <div
                className={`${
                    isOpen ? 'max-h-[2000px]' : 'max-h-0'
                } overflow-y-hidden transition-all duration-[300ms]`}
            >
                {children}
            </div>
        </div>
    );
};

export default CollapsibleSection;